import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  publishEvent(type, detail) {
    const event = new CustomEvent(type, { detail });
    this.element.dispatchEvent(event);
  }
}
